import React from 'react'
import { MaybeLoaded } from 'json-react-layouts-data-loader'

import { Whiskey } from 'component-library/collections-new/whiskey/Whiskey'
import {
    ContentDataDefinitionLoader,
    CollectionDataLoaded,
    ContentDataTypes,
} from 'common/data/loader-definitions'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from 'component-library/collections-new/collections-props.routing'
import { LoadMore } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { LoadMoreProps } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { ImageWidths } from 'common/helpers/image'
import {
    createRegisterableComponentWithData,
    ComponentServices,
} from 'common/routing/page-definition'

export interface TheWestProps extends Props {
    imageWidths?: ImageWidths['thewest']
}

interface Props extends CollectionRouteProps, LoadMoreProps {
    initialColumns?: number
    intermediateColumns?: number
    finalColumns?: number
}

type InternalWhiskeyRouteProps = Props & TheWestProps

const renderWhiskey = (
    props: InternalWhiskeyRouteProps,
    data: MaybeLoaded<CollectionDataLoaded> & {
        dataDefinitionArgs: ContentDataTypes
    },
    services: ComponentServices
) => {
    return (
        <LoadMore
            dataDefinition={data.dataDefinitionArgs}
            services={services}
            loadMoreEnabled={props.loadMoreEnabled === true}
            data={data}
            render={loadMoreData => {
                return (
                    <Whiskey
                        items={
                            loadMoreData.loaded
                                ? { loaded: true, result: loadMoreData.result.publications }
                                : { loaded: false }
                        }
                        expectedCards={calculateExpectedCardCountFromContentData(
                            data.dataDefinitionArgs
                        )}
                        initialColumns={props.initialColumns}
                        intermediateColumns={props.intermediateColumns}
                        finalColumns={props.finalColumns}
                        verticalSpacing={props.verticalSpacing}
                        onEvent={services.onEvent}
                    />
                )
            }}
        />
    )
}

export const WhiskeyRegistration = createRegisterableComponentWithData(
    'whiskey',
    ContentDataDefinitionLoader,
    (props: TheWestProps, data, services) =>
        renderWhiskey({ ...props, imageWidths: props.imageWidths }, data, services)
)
